// extracted by mini-css-extract-plugin
export default {"inline":"AnalyticsTrend_inline__bo9+o","badge":"AnalyticsTrend_badge__et7ot"};